<template>
  <div>
    <div class="d-flex flex-column">
      <div>
        <div class="d-flex justify-content-between align-items-center">
          <h5>Seleccionar Facturas</h5>
          <div class="d-flex">
            <base-input
              v-model="search"
              placeholder="Buscar..."
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="mb-2 mr-4"
              type="search"
            />
            <form @submit.prevent="getSuggestions(searchTotal, $event)" class="d-flex align-items-center mb-2" >
              <base-input
                v-model="searchTotal"
                placeholder="Buscar por Total..."
                inputClasses="input-group-alternative form-control-sm text-xs"
                class="mb-0 mr-1"
                type="number"
                min="0"
                step="0.01"
              />
              <button type="submit" class="btn btn-default btn-sm" size="sm" ref="buttonSearch"
                :disabled="searchTotal <= 0 || loadingSugg">
                <i class="fa fa-search"/>
              </button>
              <OverlayPanel ref="suggestions" appendTo="body" :baseZIndex="1051">
                <div v-if="suggestions && suggestions.length" >
                <h5>Sugerencias de Facturas:</h5>
                <div style="max-height: 350px; overflow-y: auto;">
                  <div
                    v-for="(suggestion, index) in suggestions"
                    :key="index"
                    @click="onItemSelect(suggestion)"
                    class="option-suggestion d-flex"
                  >
                  <div v-for="(item, index) in suggestion" :key="index"
                    class="mr-1 rounded text-xs font-weight-bold docnum d-flex align-items-center"
                    :title="!item.stamped ? 'Contiene facturas no timbradas' : null">
                    <i v-if="!item.stamped" class="fa fa-exclamation-triangle mr-1 fa-xs"></i>
                    {{ item.DocNum }}
                  </div>
                  </div>

                </div>
                </div>
                <div v-else-if="loadingSugg" style="width: 100%; text-wrap: initial; font-size: 12px;">
                    Buscando sugerencias de facturas...
                </div>
                <div v-else style="width: 100%; text-wrap: initial; font-size: 12px;">
                  No se encontraron combinaciones de facturas.
                </div>
              </OverlayPanel>
            </form>

          </div>
        </div>
        <ag-grid-vue
          v-bind="agInvoices"
          @grid-ready="onGridReady"
          class="ag-theme-alpine small-table"
          style="height: 330px;"
          @cell-editing-stopped="onCellEditingStopped"
          @rowSelected="onRowSelected"
          @cellClicked="onCellClicked"
        />
      </div>
    </div>

    <div
      class="d-flex align-items-center mt-3"
      :class="noStampedMsg ? 'justify-content-between' : 'justify-content-end'"
    >
      <div
        v-if="noStampedMsg"
        class="d-flex align-items-center px-3 py-1 rounded"
        style="background: #fef9c3; color: #d58e21;"
      >
        <i class="fa fa-exclamation-triangle pr-2 fa-xs"></i>
        <span class="text-xs">
          No se seleccionaron las facturas que no estan timbradas, verifica el total antes de continuar.
        </span>
      </div>
      <h4 class="text-right text-sm mr-4 m-0">
        Total: {{ currencyFormat(selectedTotal, currency.key) }}
      </h4>
    </div>

    <div 
      v-if="loadingSugg"
      style="position: fixed; inset: 0; background: rgba(255,255,255, 0.6); z-index: 999999; backdrop-filter: blur(1px);">
      <div class="d-flex flex-column justify-content-center align-items-center h-100 text-black text-center text-sm font-weight-normal">
        <i class="fa fa-spinner fa-spin fa-2x mb-4"></i>
          <b class="mb-2">Buscando sugerencias de facturas...</b>
          Por favor espere. Esta operación podría demorar.
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from "ag-grid-vue";
import Formats from "@/mixins/Formats";
import EmptySection from "@/components/EmptySection";
import BaseLoader from "@/components/BaseLoader";
import OverlayPanel from "primevue/overlaypanel";

export default {
  name: "SelectInvoices",
  mixins: [Formats],
  components: {
    AgGridVue,
    EmptySection,
    BaseLoader,
    OverlayPanel,
  },
  props: {
    availableInvoices: {
      type: Array,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedTotal: 0,
      search: "",
      apiInvoices: null,
      suggestions: null,
      loadingSugg: false,
      searchTotal: null,
      currentTotalSearch: null,
      noStampedMsg: false,
      agInvoices: {
        rowData: null,
        columnDefs: [
          {
            headerName: "",
            suppressSizeToFit: true,
            children: [
              {
                headerName: "Factura",
                field: "DocNum",
                width: 100,
                cellClass: "font-weight-bold",
                cellStyle: { cursor: "pointer" },
                headerCheckboxSelection: true,
                checkboxSelection: true,
              },
              {
                headerName: "Referencia",
                field: "NumAtCard",
                width: 80,
              },
            ],
          },

          {
            headerName: "Fecha",
            suppressSizeToFit: true,
            children: [
              {
                headerName: "Contable",
                field: "TaxDate",
                width: 85,
              },
              {
                headerName: "Vencimiento",
                field: "DocDueDate",
                width: 85,
              },
            ],
          },
          {
            headerName: "Monto",
            children: [
              {
                headerName: "Total",
                valueGetter: this.invoiceTotalGetter,
                valueFormatter: (params) => this.currencyFormat(params.value, params.data.DocCurrency),
                type: "rightAligned",
                width: 120,
              },
              {
                headerName: "Pendiente",
                valueGetter: (params) => this.invoicePendingGetter(params.data),
                valueFormatter: (params) => this.currencyFormat(params.value, params.data.DocCurrency),
                type: "rightAligned",
                width: 120,
              },
              {
                headerName: "A aplicar *",
                field: "charge",
                editable: (params) => params.node.isSelected() && (params.data.U_WebUUID || params.data.U_TS_ReportID),
                cellEditor: "agNumberCellEditor",
                valueFormatter: (params) => this.currencyFormat(params.value, params.data.DocCurrency),
                tooltipValueGetter: (params) =>
                  params.node.isSelected() && (params.data.U_WebUUID || params.data.U_TS_ReportID) ? "Editar" : null,
                cellClass: (params) => params.value && params.node.isSelected() ? "ag-editable-cell text-right" : "text-right",
                type: "rightAligned",
                width: 120,
                valueSetter: (params) => {
                  const pending = this.invoicePendingGetter(params.data);
                  if (params.newValue <= pending.toFixed(2)) {
                    params.data.charge = params.newValue;
                    return true;
                  }
                },
                cellEditorParams: {
                  min: 0,
                },
              },
            ],
          },
        ],
        noRowsOverlayComponent: "EmptySection",
        loadingOverlayComponent: "BaseLoader",
        tooltipShowDelay: 0,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenCellsLoseFocus: true,
        cacheQuickFilter: true,
        suppressCellFocus: true,
        enableCellTextSelection: true,
        defaultColDef: {
          suppressHeaderMenuButton: true,
          tooltipValueGetter: ({ data }) => {
            if (!data.U_WebUUID && !data.U_TS_ReportID) {
              return "Esta factura no ha sido timbrada";
            }
          },
        },
        getRowClass: ({ data }) => {
          if (!data.U_WebUUID && !data.U_TS_ReportID) {
            return "opacity-5";
          }
        },
        isRowSelectable: ({ data }) => {
          return data.U_WebUUID || data.U_TS_ReportID;
        },
        suppressHorizontalScroll: true,
        alwaysShowVerticalScroll: true,
        suppressMovableColumns: true,
      },
    };
  },
  created() {},
  methods: {
    onCellClicked(params) {
      if (params.column.colId === "DocNum") {
        params.node.setSelected(!params.node.isSelected());
        this.noStampedMsg = false;
      }
    },
    onRowSelected(params) {
      if (params.node.isSelected()) {
        const newValue = this.invoicePendingGetter(params.data).toFixed(2);
        params.node.setDataValue("charge", parseFloat(newValue));
      } else {
        params.node.setDataValue("charge", null);
      }
      this.emitUpdate();
      if (params.source !== "api") {
        this.noStampedMsg = false;
      }
    },
    invoiceTotalGetter(params) {
      const totalField = params.data.DocCurrency === "MXP" ? "DocTotal" : "DocTotalFc";
      return params.data[totalField];
    },
    invoicePendingGetter(data) {
      const totalField = data.DocCurrency === "MXP" ? "DocTotal" : "DocTotalFc";
      return data[totalField] - data.sum;
    },
    onGridReady(params) {
      this.apiInvoices = params.api;
      this.apiInvoices.sizeColumnsToFit();
    },
    onCellEditingStopped(params) {
      params.api.forEachNode((node) => {
        if (!node.data.charge) {
          node.setSelected(false);
          if (node.data.DocNum === params.data.DocNum) {
            this.noStampedMsg = false;
          }
        }
      });
      this.search = null;
      this.emitUpdate();
    },
    emitUpdate() {
      const selected = this.apiInvoices.getSelectedRows();
      this.selectedTotal = selected.reduce((acc, curr) => acc + curr.charge, 0) || 0;
      this.selectedTotal = parseFloat(this.selectedTotal.toFixed(2));
      this.$emit("updated", selected, this.selectedTotal);
      this.apiInvoices.sizeColumnsToFit();
    },
    resetSelected() {
      this.agInvoices.rowData = [];
      this.apiInvoices.setGridOption("rowData", this.agInvoices.rowData);
      this.selectedTotal = 0;
      this.searchTotal = null;
      this.noStampedMsg = false;
      this.suggestions = null;
      this.currentTotalSearch = null;
    },
    async getSuggestions(value, event) {
      if (!value) return;
      if (this.currentTotalSearch === value) {
        this.$refs.suggestions.show(event);
        return;
      }
      this.loadingSugg = true;
      let result = [];
      this.suggestions = null;
      this.$refs.suggestions.hide();

      const total = parseFloat(value);
      const filteredInvoices = this.availableInvoices
        .map((invoice) => {
          return {
            DocNum: invoice.DocNum,
            pending: this.invoicePendingGetter(invoice),
            stamped: invoice.U_WebUUID || invoice.U_TS_ReportID,
          };
        })
        .filter((invoice) => invoice.pending > 0 && invoice.pending <= total)
        .sort((a, b) => b.pending - a.pending); // Orden descendente

      setTimeout(() => {
        try {
            // Simplificación de la memoización utilizando un Set
            const visited = new Set();
  
            const findCombination = (index, currentCombination, currentSum) => {
              const fixedSum = parseFloat(currentSum.toFixed(2));

              // // Limitar el número de combinaciones
              if(result.length > 20) {
                return;
              }

              // Caso base: si encontramos el total exacto
              if (fixedSum === total) {
                result.push([...currentCombination]);
                return;
              }
  
              // Si excedemos el total o no hay más facturas, detener
              if (fixedSum > total || index === filteredInvoices.length) {
                return;
              }
  
              // Crear una clave única para memoización (index + suma actual)
              const memoKey = `${index}${fixedSum}`;
              if (visited.has(memoKey)) return;
              visited.add(memoKey);
  
              // Incluir la factura actual
              const sum = parseFloat((currentSum + filteredInvoices[index].pending).toFixed(2));
              if (sum <= total) {
                findCombination(
                  index + 1,
                  [...currentCombination, filteredInvoices[index]],
                  sum
                );
              }
  
              // Omitir la factura actual
              findCombination(index + 1, currentCombination, fixedSum);
            };
  
            // Iniciar búsqueda
            findCombination(0, [], 0);
  
            if (result.length > 0) {
              this.suggestions = result;
              console.log("Combinaciones exactas encontradas:", result);

            } else {
              console.log("No se encontraron combinaciones exactas.");
              this.suggestions = [];
            }

        } catch (err) {
          if (result.length > 0) { // Combinaciones encontradas antes del error
            this.suggestions = result;
          } else {
            this.suggestions = [];
            this.$swal({
              title: "Error",
              text: "No se pudo completar la búsqueda de facturas",
              icon: "error",
              customClass: {
                container: "custom-swal-on-top",
              },
            });
          }
          console.error("Error al leer el archivo o procesar las facturas:", err.message);

        } finally {
          this.loadingSugg = false;
          this.currentTotalSearch = value;

          this.$nextTick(() => {
            if (this.$refs.buttonSearch) {
              this.$refs.buttonSearch.click();
            }
          });
        }
      }, 1000);
    },
    onItemSelect(item) {
      const docNums = item.map((x) => x.DocNum);
      const indexes = [];
      this.apiInvoices.forEachNode((node) => {
        if (docNums.includes(node.data.DocNum)) {
          node.setSelected(true);
          indexes.push(node.rowIndex);
        } else {
          node.setSelected(false);
        }
      });
      const minIndex = Math.min(...indexes);
      this.apiInvoices.ensureIndexVisible(minIndex, "top");
      if (item.find((x) => !x.stamped)) {
        this.noStampedMsg = true;
      } else {
        this.noStampedMsg = false;
      }
      this.$refs.suggestions.hide();
    },
  },
  computed: {},
  watch: {
    search(newValue) {
      this.apiInvoices.setGridOption("quickFilterText", newValue);
      this.apiInvoices.sizeColumnsToFit();
    },
    availableInvoices: {
      handler(newValue) {
        this.agInvoices.rowData = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.ag-theme-alpine.small-table {
  --ag-font-size: 11px;
  --ag-cell-horizontal-padding: 8px;
}
.ag-editable-cell {
  cursor: text;
}
.ag-editable-cell:hover {
  background: #c7d2fe;
}

.option-suggestion{
  cursor: pointer;
  padding: 5px 15px;
  margin: 5px 0;
  border-radius: 5px;
}
.option-suggestion:hover{
  background: #f1f5f9;
}
.docnum{
  background: #e2e8f0;
  padding: 2px 5px;
  letter-spacing: 0.6px;
}
.option-suggestion:hover .docnum{
  background: #64748b;
  color: white;
}
.custom-swal-on-top {
  z-index: 9999 !important;
}

</style>
